import { CohortEnumSchema } from '@eigtech/auth0-types';
export const roleToCohort = {
    'CSR - Project Manager': CohortEnumSchema.enum.csr,
    'CSR - Reviewer': CohortEnumSchema.enum.csr,
    'CSR - Super Admin': CohortEnumSchema.enum.csr,
    'CSR - User': CohortEnumSchema.enum.csr,
    'Desk Adjuster': CohortEnumSchema.enum.estimator,
    'Estimator - User': CohortEnumSchema.enum.estimator,
    'TPLAP - Field Technician': CohortEnumSchema.enum.technician,
    'TPLAP - Subcontractor': CohortEnumSchema.enum.technician,
    'TPLAP - User': CohortEnumSchema.enum.insured,
    'Ultra Super Admin': CohortEnumSchema.enum.super,
};
